import { useEffect, useId, type ReactNode } from "react";

/** Modal panel: a bottom sheet on phones, a centred dialog on larger screens. `full` fills the screen on phones, e.g. for writing longer texts. */
export function Sheet(props: { title: string; onClose: () => void; children: ReactNode; footer?: ReactNode; wide?: boolean; full?: boolean }) {
  const titleId = useId();
  const { onClose } = props;
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.classList.add("no-scroll");
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.classList.remove("no-scroll");
    };
  }, [onClose]);

  return (
    <div className="sheet-backdrop" onClick={onClose}>
      <div
        className={`sheet${props.wide ? " sheet-wide" : ""}${props.full ? " sheet-full" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="sheet-header">
          <h2 id={titleId}>{props.title}</h2>
          <button type="button" className="icon-button" aria-label="Schließen" onClick={onClose}>
            ×
          </button>
        </header>
        <div className="sheet-body">{props.children}</div>
        {props.footer && <footer className="sheet-footer">{props.footer}</footer>}
      </div>
    </div>
  );
}
